module.exports = __webpack_public_path__ + "static/img/国庆新闻.6baccc08.jpg";